import {
  actionCreator,
  checkHttpStatus,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  BehaviorCategoryActionTypes,
  GET_BEHAVIOR_CATEGORY_LIST_API,
  POST_BEHAVIOR_CATEGORY_API,
  GET_BEHAVIOR_CATEGORY_DETAILS_API,
  DELETE_BEHAVIOR_CATEGORY_API,
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck,createSearchUrlForCustomAPI, showWarningMessage } from '../../../../actions/utilAction';

export const getBehaviorCategoryList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BehaviorCategoryActionTypes.get_behaviorCategoryList.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_BEHAVIOR_CATEGORY_LIST_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(BehaviorCategoryActionTypes.get_behaviorCategoryList.SUCCESS, response));
        } else {
          dispatch(actionCreator(BehaviorCategoryActionTypes.get_behaviorCategoryList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_behaviorCategoryList ', error);
      });
  };
};

export const saveBehaviorCategory = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BehaviorCategoryActionTypes.post_behaviorCategory.REQUEST));
    fetch(POST_BEHAVIOR_CATEGORY_API, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(BehaviorCategoryActionTypes.post_behaviorCategory.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(BehaviorCategoryActionTypes.post_behaviorCategory.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_behaviorCategory', error);
      });
  };
};

export const getBehaviorCategoryDetails = (BehaviorCategoryId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BehaviorCategoryActionTypes.get_behaviorCategoryDetails.REQUEST));
    fetch(`${GET_BEHAVIOR_CATEGORY_DETAILS_API}?behaviorCategoryId=${BehaviorCategoryId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(BehaviorCategoryActionTypes.get_behaviorCategoryDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(BehaviorCategoryActionTypes.get_behaviorCategoryDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error get_behaviorCategoryDetails ', error);
      });
  };
};

export const deleteBehaviorCategory = (BehaviorCategoryId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BehaviorCategoryActionTypes.delete_behaviorCategory.REQUEST));
    fetch(`${DELETE_BEHAVIOR_CATEGORY_API}?behaviorCategoryId=${BehaviorCategoryId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200 || response.statusCode === 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(BehaviorCategoryActionTypes.delete_behaviorCategory.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(BehaviorCategoryActionTypes.delete_behaviorCategory.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(BehaviorCategoryActionTypes.delete_behaviorCategory.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error delete_behaviorCategory', error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/behaviourCategory/actions/behaviourCategoryActions.js